import React, { useState, useEffect } from 'react';
import axios from 'axios';

const AddOpportunityModal = ({ isOpen, onClose, username, user_id }) => {
  // Form state
  const [formData, setFormData] = useState({
    lead_id: '',
    username: username || 'test_fur',
    user_id: user_id || '420',
    type: 'referral',
    referralType: '',
    userType: 'existing',
    referrerCompanyName: '',
    referrerCompanyId: '',
    referrerContactName: '',
    referrerPhone: '',
    referrerEmail: '',
    referredCompanyName: '',
    referredCompanyId: '',
    referredContactName: '',
    referredPhone: '',
    referredEmail: '',
    description: '',
  });
  const  userId = 420
  // UI state
  const [showFullForm, setShowFullForm] = useState(false);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [similarCompanies, setSimilarCompanies] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [errors, setErrors] = useState({});
  const [companyOptions, setCompanyOptions] = useState([]);
  const [loadingCompanies, setLoadingCompanies] = useState(false);
  const [submitStatus, setSubmitStatus] = useState({ success: false, message: '' });

  // Fetch companies when modal opens
//   useEffect(() => {
//     const fetchCompanies = async () => {
//       if (!isOpen) return;
      
//       setLoadingCompanies(true);
//       try {
//         const response = await axios.get(`${import.meta.env.VITE_BASE_URL}/api/companies/referralff?user_id=${userId}`, );
//         const companies = response.data.map(company => ({
//           id: company.id,
//           name: company.company_name || company.name || ''
//         })).filter(company => company.name);
        
//         setCompanyOptions(companies);
//       } catch (error) {
//         console.error("Error fetching companies:", error);
//       } finally {
//         setLoadingCompanies(false);
//       }
//     };

//     fetchCompanies();
//   }, [isOpen]);

useEffect(() => {
    const fetchCompanies = async () => {
      if (!isOpen || !formData.referralType) return;
      
      setLoadingCompanies(true);
      try {
        let endpoint = '';
        
        // Determine endpoint based on referral type
        if (formData.referralType === 'active') {
          endpoint = `${import.meta.env.VITE_BASE_URL}/api/companies?user_id=${userId}`;
        } else if (formData.referralType === 'special') {
          endpoint = `${import.meta.env.VITE_BASE_URL}/api/companies?user_id=${userId}`;
        } else if (formData.referralType === 'ff') {
          endpoint = `${import.meta.env.VITE_BASE_URL}/api/companies?user_id=${userId}`;
        }
        
        if (endpoint) {
          const response = await axios.get(endpoint);
          const companies = response.data.map(company => ({
            id: company.id,
            name: company.company_name || company.name || ''
          })).filter(company => company.name);
          
          setCompanyOptions(companies);
        }
      } catch (error) {
        console.error("Error fetching companies:", error);
      } finally {
        setLoadingCompanies(false);
      }
    };
  
    fetchCompanies();
  }, [isOpen, formData.referralType]); // Add formData.referralType as dependency

  const handleChange = (e) => {
    const { name, value } = e.target;
    
    if (name === 'userType') {
      setFormData(prev => ({
        ...prev,
        [name]: value,
        referrerCompanyName: '',
        referrerCompanyId: ''
      }));
    } 
    else if (name === 'referrerCompanyName' || name === 'referredCompanyName') {
      const selectedCompany = companyOptions.find(company => company.name === value);
      setFormData(prev => ({
        ...prev,
        [name]: value,
        [`${name.replace('Name', 'Id')}`]: selectedCompany ? selectedCompany.id : '',
        lead_id: selectedCompany ? selectedCompany.id : prev.lead_id
      }));
    } 
    else if (name === 'referralType') {
        setFormData(prev => ({
          ...prev,
          [name]: value,
          // If changing from 'nonexisting' to any referralType except 'ff',
          // automatically set userType to 'existing'
          userType: (prev.userType === 'nonexisting' && value !== 'ff') 
            ? 'existing' 
            : prev.userType
        }));
      } 
    else {
      setFormData(prev => ({ ...prev, [name]: value }));
    }
    
    if (errors[name]) {
      setErrors(prev => ({ ...prev, [name]: '' }));
    }
    
    if (name === 'referralType' && value) {
      setShowFullForm(true);
    }
  };

  const validateForm = () => {
    const newErrors = {};
    
    if (!formData.referralType) newErrors.referralType = 'Required';
    if (!formData.referrerCompanyName) newErrors.referrerCompanyName = 'Required';
    if (!formData.referredCompanyName) newErrors.referredCompanyName = 'Required';
    if (formData.referralType === 'ff' && !formData.userType) {
      newErrors.userType = 'Required';
    }
    
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmitOpportunity = async (finalFormData) => {
    try {
      const submissionData = {
        ...finalFormData,
        lead_id: finalFormData.referrerCompanyId || '',
      };

      if (submissionData.referralType ==='ff'){

        if (submissionData.userType === 'farmer') {
            await axios.post(`${import.meta.env.VITE_BASE_URL}/api/submit_ff_opp_farmer`, submissionData);
          } else if (submissionData.userType === 'existing') {
            await axios.post(`${import.meta.env.VITE_BASE_URL}/api/submit_ff_opp_existing`, submissionData);
          } else if (submissionData.userType === 'nonexisting') {
            await axios.post(`${import.meta.env.VITE_BASE_URL}/api/submit_ff_opp_nonexisting`, submissionData);
          } else {
            return { success: false, message: 'Invalid user type' };
          }
      }
      else if (submissionData.referralType ==='active' || submissionData.referralType ==='special'){

        await axios.post(`${import.meta.env.VITE_BASE_URL}/api/submit_refferal_active_special`, submissionData);

      }
  
      window.location.href = '/referral';
      return { success: true, message: 'Opportunity created successfully!' };
    } catch (error) {
      console.error('Submission error:', error);
      return { 
        success: false, 
        message: error.response?.data?.message || 'Failed to create opportunity' 
      };
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!validateForm()) return;
    
    setIsSubmitting(true);

    try {
      if (formData.referralType === 'ff' && formData.userType === 'nonexisting') {
        const response = await axios.post(`${import.meta.env.VITE_BASE_URL}/api/companies/fuzzy-search`, {
          searchTerm: formData.referrerCompanyName
        });
        
        setSimilarCompanies(response.data);
        
        if (response.data && response.data.length > 0) {
          setShowConfirmation(true);
          setIsSubmitting(false);
          return;
        }
      }
      
      const result = await handleSubmitOpportunity(formData);
      setSubmitStatus(result);
      
      if (result.success) {
        setTimeout(() => {
          onClose();
          setSubmitStatus({ success: false, message: '' });
          setSelectedCompany(null);
        }, 1500);
      }
    } catch (error) {
      console.error('Error during submission:', error);
      setSubmitStatus({ success: false, message: 'An unexpected error occurred' });
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleConfirmation = async (useExisting) => {
    setShowConfirmation(false);
    setIsSubmitting(true);
  
    try {
      let dataToSubmit;
      let result;
      
      if (useExisting && selectedCompany) {
        dataToSubmit = {
          ...formData,
          userType: 'existing',
          referredCompanyName: formData.referredCompanyName,
          referredContactName: formData.referredContactName,
          referredPhone: formData.referredPhone,
          referredEmail: formData.referredEmail,
          lead_id: selectedCompany.id
        };
  
        await axios.post(`${import.meta.env.VITE_BASE_URL}/api/submit_ff_opp_existing`, dataToSubmit);
        result = { success: true, message: 'Opportunity created successfully!' };
      } else {
        result = await handleSubmitOpportunity(formData);
      }
  
      setSubmitStatus(result);
      
      if (result.success) {
        setTimeout(() => {
          onClose();
          setFormData({
            lead_id: '',
            username: username || 'test_fur',
            user_id: user_id || '420',
            type: 'referral',
            referralType: '',
            userType: '',
            referrerCompanyName: '',
            referrerCompanyId: '',
            referrerContactName: '',
            referrerPhone: '',
            referrerEmail: '',
            referredCompanyName: '',
            referredCompanyId: '',
            referredContactName: '',
            referredPhone: '',
            referredEmail: '',
            description: '',
          });
          setShowFullForm(false);
          setSelectedCompany(null);
        }, 1500);
      }
    } catch (error) {
      console.error('Error during confirmation:', error);
      setSubmitStatus({ 
        success: false, 
        message: error.response?.data?.message || 'Failed to create opportunity' 
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  const CompanyTable = ({ companies, selectedCompany, onSelect, highlight }) => {
    return (
      <table className="min-w-full divide-y divide-gray-200">
        <thead className="bg-gray-50">
          <tr>
            <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Select</th>
            <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Company</th>
            <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Contact</th>
            <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Phone</th>
            <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Match Score</th>
          </tr>
        </thead>
        <tbody className="bg-white divide-y divide-gray-200">
          {companies.map(company => (
            <tr 
              key={company.id}
              className={`
                ${highlight === 'perfect' ? 'bg-green-50' : ''}
                ${selectedCompany?.id === company.id ? 'bg-blue-50' : ''}
                hover:bg-gray-50
              `}
            >
              <td className="px-4 py-4 whitespace-nowrap">
                <input
                  type="radio"
                  checked={selectedCompany?.id === company.id}
                  onChange={() => onSelect(company)}
                  className="h-4 w-4 text-blue-600 focus:ring-blue-500"
                />
              </td>
              <td className="px-4 py-4 whitespace-nowrap text-sm text-gray-900">
                {company.company_name}
              </td>
              <td className="px-4 py-4 whitespace-nowrap text-sm text-gray-500">
                {company.contact_name || 'N/A'}
              </td>
              <td className="px-4 py-4 whitespace-nowrap text-sm text-gray-500">
                {company.phone || 'N/A'}
              </td>
              <td className={`px-4 py-4 whitespace-nowrap text-sm ${
                highlight === 'perfect' ? 'text-green-700 font-bold' : 'text-gray-500'
              }`}>
                {company.score}%
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    );
  };

  const renderConfirmationModal = () => {
    const allMatches = [...similarCompanies];
    const perfectMatches = allMatches.filter(c => c.score === 100);
    const otherMatches = allMatches.filter(c => c.score < 100);

    return (
      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
        <div className="bg-white rounded-lg p-6 w-full max-w-4xl max-h-[80vh] flex flex-col">
          <button
            onClick={() => setShowConfirmation(false)}
            className="absolute top-4 right-4 text-gray-500 hover:text-gray-700 focus:outline-none"
          >
            <svg 
              xmlns="http://www.w3.org/2000/svg" 
              className="h-6 w-6" 
              fill="none" 
              viewBox="0 0 24 24" 
              stroke="currentColor"
            >
              <path 
                strokeLinecap="round" 
                strokeLinejoin="round" 
                strokeWidth={2} 
                d="M6 18L18 6M6 6l12 12" 
              />
            </svg>
          </button>
          
          <h3 className="text-xl font-bold mb-4 text-gray-800">Similar Companies</h3>
          
          <div className="flex-1 overflow-y-auto">
            {perfectMatches.length > 0 && (
              <div className="mb-6">
                <h4 className="font-bold text-green-700 mb-2">Exact Matches (100%)</h4>
                <CompanyTable 
                  companies={perfectMatches}
                  selectedCompany={selectedCompany}
                  onSelect={setSelectedCompany}
                  highlight="perfect"
                />
              </div>
            )}

            {otherMatches.length > 0 && (
              <div>
                <h4 className="font-bold text-gray-700 mb-2">Other Similar Companies</h4>
                <CompanyTable
                  companies={otherMatches}
                  selectedCompany={selectedCompany}
                  onSelect={setSelectedCompany}
                />
              </div>
            )}

            {allMatches.length === 0 && (
              <p className="text-gray-500 py-4">No similar companies found</p>
            )}
          </div>

          <div className="flex justify-end gap-4 mt-4">
            <button 
              onClick={() => handleConfirmation(false)}
              className="px-4 py-2 bg-gray-200 text-gray-800 rounded-md hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-gray-500"
              disabled={isSubmitting}
            >
              Create New
            </button>
            <button
              onClick={() => handleConfirmation(true)}
              disabled={!selectedCompany || isSubmitting}
              className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {isSubmitting ? 'Processing...' : 'Use Selected'}
            </button>
          </div>
        </div>
      </div>
    );
  };

//   const renderCompanyInput = (fieldName) => {
//     const isReferrer = fieldName === 'referrerCompanyName';
//     const idField = isReferrer ? 'referrerCompanyId' : 'referredCompanyId';
    
//     if (fieldName === 'referrerCompanyName') {
//       if ((formData.referralType === 'ff' && 
//           (formData.userType === 'farmer' || formData.userType === 'existing')) || formData.referralType === 'active' || formData.referralType === 'special') {
//         if (companyOptions.length === 0 && !loadingCompanies) {
//           return (
//             <div className="mb-1">
//               <label className="block text-sm font-medium text-gray-700 mb-1">Company Name*</label>
//               <input
//                 type="text"
//                 name={fieldName}
//                 value={formData[fieldName]}
//                 onChange={handleChange}
//                 className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-yellow-300"
//                 required
//               />
//             </div>
//           );
//         }
  
//         return (
//           <div className="mb-1">
//             <label className="block text-sm font-medium text-gray-700 mb-1">Company Name*</label>
//             <select
//               name={fieldName}
//               value={formData[fieldName]}
//               onChange={handleChange}
//               className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-yellow-300"
//               disabled={loadingCompanies}
//               required
//             >
//               <option value="">{loadingCompanies ? "Loading companies..." : "Select Company"}</option>
//               {companyOptions.map(company => (
//                 <option key={company.id} value={company.name}>
//                   {company.name}
//                 </option>
//               ))}
//             </select>
//             <input type="hidden" name={idField} value={formData[idField]} />
//           </div>
//         );
//       }
//     }
    
//     return (
//       <div className="mb-1">
//         <label className="block text-sm font-medium text-gray-700 mb-1">Company Name*</label>
//         <input
//           type="text"
//           name={fieldName}
//           value={formData[fieldName]}
//           onChange={handleChange}
//           className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-yellow-300"
//           required
//         />
//       </div>
//     );
//   };

// Update your renderCompanyInput function to handle different cases
const renderCompanyInput = (fieldName) => {
    const isReferrer = fieldName === 'referrerCompanyName';
    const idField = isReferrer ? 'referrerCompanyId' : 'referredCompanyId';
    
    if (isReferrer) {
      // For referrer company name - show dropdown for existing companies when applicable
      if ((formData.referralType === 'ff' && formData.userType !== 'nonexisting') || 
          formData.referralType === 'active' || 
          formData.referralType === 'special') {
        return (
          <div className="mb-1">
            <label className="block text-sm font-medium text-gray-700 mb-1">Company Name*</label>
            <select
              name={fieldName}
              value={formData[fieldName]}
              onChange={handleChange}
              className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-yellow-300"
              disabled={loadingCompanies}
              required
            >
              <option value="">{loadingCompanies ? "Loading companies..." : "Select Company"}</option>
              {companyOptions.map(company => (
                <option key={company.id} value={company.name}>
                  {company.name}
                </option>
              ))}
            </select>
            <input type="hidden" name={idField} value={formData[idField]} />
            {errors[fieldName] && <p className="mt-1 text-sm text-red-600">{errors[fieldName]}</p>}
          </div>
        );
      }
    }
    
    // Default case - show text input
    return (
      <div className="mb-1">
        <label className="block text-sm font-medium text-gray-700 mb-1">Company Name*</label>
        <input
          type="text"
          name={fieldName}
          value={formData[fieldName]}
          onChange={handleChange}
          className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-yellow-300"
          required
        />
        {errors[fieldName] && <p className="mt-1 text-sm text-red-600">{errors[fieldName]}</p>}
      </div>
    );
  };

  if (!isOpen) return null;

  return (
    <div onClick={onClose}>
      {submitStatus.message && (
        <div className={`fixed top-4 right-4 p-4 rounded-md z-50 ${
          submitStatus.success ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'
        }`}>
          {submitStatus.message}
        </div>
      )}

      <div className="fixed inset-0 z-[60] bg-black bg-opacity-50 flex items-center justify-center z-40 ">
        <div onClick={(e) => e.stopPropagation()} className="bg-white rounded-lg p-8 w-full max-w-3xl max-h-[90vh] overflow-y-auto ">
            <div className="flex justify-between items-start w-full border-b border-gray-300 mr-5 mb-6">
            <h2 className="text-2xl font-bold mb-2 text-gray-800">Add New Opportunity</h2>
            </div>
          
          
          <form onSubmit={handleSubmit} className="space-y-6">
            <div className="flex gap-4">
              <div className="flex-1">
                <label className="block text-sm font-medium text-gray-700 mb-1">Type</label>
                <select
                  name="type"
                  value={formData.type}
                  onChange={handleChange}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-green-500"
                  disabled={showFullForm}
                >
                  <option value="referral">Referral</option>
                  <option value="sales">Sales</option>
                </select>
              </div>
              
              <div className="flex-1">
                <label className="block text-sm font-medium text-gray-700 mb-1">Referral Type*</label>
                <select
                  name="referralType"
                  value={formData.referralType}
                  onChange={handleChange}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-green-500"
                  required
                >
                  <option value="">Select Referral Type</option>
                  <option value="active">Referral Active</option>
                  <option value="special">Referral Special</option>
                  <option value="ff">Referral F&F</option>
                </select>
                {errors.referralType && <p className="mt-1 text-sm text-red-600">{errors.referralType}</p>}
              </div>
            </div>

            {showFullForm && (
                <div className="space-y-5">
                    {/* User Type Radio Buttons (Unchanged) */}
                    {formData.referralType === 'ff' && (
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">User Type*</label>
                        <div className="flex gap-6">
                        {['farmer', 'existing', 'nonexisting'].map(type => (
                            <label key={type} className="inline-flex items-center">
                            <input
                                type="radio"
                                name="userType"
                                value={type}
                                checked={formData.userType === type}
                                onChange={handleChange}
                                disabled={type === 'farmer'}
                                className={`h-4 w-4 focus:ring-green-500 ${
                                type === 'farmer' ? 'text-gray-400 cursor-not-allowed' : 'text-green-600'
                                }`}
                            />
                            <span className="ml-2 text-gray-700">
                                {type === 'farmer' ? 'Farmer' : 
                                type === 'existing' ? 'Existing' : 'Non-existing'}
                            </span>
                            </label>
                        ))}
                        </div>
                        {errors.userType && <p className="mt-1 text-sm text-red-600">{errors.userType}</p>}
                    </div>
                    )}

                    {/* Referrer Section (Conditional Fields) */}
                    <div className="border-b pb-6">
                    <h3 className="text-lg font-medium text-gray-900 mb-4">Referrer Information</h3>
                    
                    {renderCompanyInput('referrerCompanyName')}
                    {errors.referrerCompanyName && <p className="mt-1 text-sm text-red-600">{errors.referrerCompanyName}</p>}

                    {/* Only show these fields if userType is 'nonexisting' */}
                    {formData.userType === 'nonexisting' && (
                        <>
                        <div className="mb-4">
                            <label className="block text-sm font-medium text-gray-700 mb-1">Contact Name*</label>
                            <input
                            type="text"
                            name="referrerContactName"
                            value={formData.referrerContactName}
                            onChange={handleChange}
                            className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-yellow-300"
                            required={formData.userType === 'nonexisting'}
                            />
                            {errors.referrerContactName && <p className="mt-1 text-sm text-red-600">{errors.referrerContactName}</p>}
                        </div>

                        <div className="flex gap-4">
                            <div className="flex-1">
                            <label className="block text-sm font-medium text-gray-700 mb-1">Phone Number*</label>
                            <input
                                type="tel"
                                name="referrerPhone"
                                value={formData.referrerPhone}
                                onChange={handleChange}
                                className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-green-500"
                                required={formData.userType === 'nonexisting'}
                            />
                            {errors.referrerPhone && <p className="mt-1 text-sm text-red-600">{errors.referrerPhone}</p>}
                            </div>
                            <div className="flex-1">
                            <label className="block text-sm font-medium text-gray-700 mb-1">Email*</label>
                            <input
                                type="email"
                                name="referrerEmail"
                                value={formData.referrerEmail}
                                onChange={handleChange}
                                className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-green-500"
                                required={formData.userType === 'nonexisting'}
                            />
                            {errors.referrerEmail && <p className="mt-1 text-sm text-red-600">{errors.referrerEmail}</p>}
                            </div>
                        </div>
                        </>
                    )}
                    </div>

                    {/* Referred Section (Unchanged - Always Visible) */}
                    <div className="border-b pb-6">
                    <h3 className="text-lg font-medium text-gray-900 mb-4">Referred Information</h3>
                    
                    {renderCompanyInput('referredCompanyName')}
                    {errors.referredCompanyName && <p className="mt-1 text-sm text-red-600 ">{errors.referredCompanyName}</p>}

                    <div className="mb-4">
                        <label className="block text-sm font-medium text-gray-700 mb-1">Contact Name*</label>
                        <input
                        type="text"
                        name="referredContactName"
                        value={formData.referredContactName}
                        onChange={handleChange}
                        className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-yellow-300"
                        required
                        />
                        {errors.referredContactName && <p className="mt-1 text-sm text-red-600">{errors.referredContactName}</p>}
                    </div>

                    <div className="flex gap-4">
                        <div className="flex-1">
                        <label className="block text-sm font-medium text-gray-700 mb-1">Phone Number*</label>
                        <input
                            type="tel"
                            name="referredPhone"
                            value={formData.referredPhone}
                            onChange={handleChange}
                            className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-yellow-300"
                            required
                        />
                        {errors.referredPhone && <p className="mt-1 text-sm text-red-600">{errors.referredPhone}</p>}
                        </div>
                        <div className="flex-1">
                        <label className="block text-sm font-medium text-gray-700 mb-1">Email*</label>
                        <input
                            type="email"
                            name="referredEmail"
                            value={formData.referredEmail}
                            onChange={handleChange}
                            className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-yellow-300"
                            required
                        />
                        {errors.referredEmail && <p className="mt-1 text-sm text-red-600">{errors.referredEmail}</p>}
                        </div>
                    </div>
                    </div>

                    {/* Submit/Cancel Buttons (Unchanged) */}
                    <div className="flex justify-end gap-3 pt-0">
                    <button
                        type="button"
                        onClick={onClose}
                        className="px-4 py-2 bg-white border-[1px] border-black rounded-3xl hover:bg-gray-100 font-medium"
                        disabled={isSubmitting}
                    >
                        Cancel
                    </button>
                    <button
                        type="submit"
                        className={`px-4 py-2 rounded-3xl text-black  bg-yellow-300 hover:bg-yellow-400 font-medium ${
                        isSubmitting ? 'opacity-75 cursor-not-allowed' : ''
                        }`}
                        disabled={isSubmitting}
                    >
                        {isSubmitting ? 'Processing...' : 'Submit'}
                    </button>
                    </div>
                </div>
                )}
          </form>
        </div>
      </div>

      {showConfirmation && renderConfirmationModal()}
    </div>
  );
};

export default AddOpportunityModal;